import safeGet from './safeGet'

export default safeGet
